import React, { useEffect } from "react";
import Pdf from "../../editable-stuff/Résumé.pdf";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Container from "react-bootstrap/Container";

import axios from "axios";

const pictureLinkRegex = new RegExp(
  /[(http(s)?):(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
);

const AboutMe = ({ heading, message, link, imgSize, resume, isDarkMode }) => {
  const [profilePicUrl, setProfilePicUrl] = React.useState("");
  const [showPic, setShowPic] = React.useState(Boolean(link));

  const controlsOne = useAnimation();
  const [refOne, inViewOne] = useInView();
  const controlsTwo = useAnimation();
  const [refTwo, inViewTwo] = useInView();

  const appearUp = {
    visible: { opacity: 1, y: 0, transition: { duration: 1 }, delay: "0" },
    hidden: { opacity: 0, y: 10 },
  };

  useEffect(() => {
    if (inViewOne) {
      controlsOne.start("visible");
    } else {
      controlsOne.start("hidden");
    }
    if (inViewTwo) {
      controlsTwo.start("visible");
    } else {
      controlsTwo.start("hidden");
    }
  }, [controlsOne, inViewOne, controlsTwo, inViewTwo]);

  React.useEffect(() => {
    if (link && !pictureLinkRegex.test(link)) {
      handleRequest();
    } else {
      setProfilePicUrl(link);
    }
  }, [link]);

  const handleRequest = async () => {
    const instaLink = "https://www.instagram.com/";
    const instaQuery = "/?__a=1";
    try {
      const response = await axios.get(instaLink + link + instaQuery);
      setProfilePicUrl(response.data.graphql.user.profile_pic_url_hd);
    } catch (error) {
      setShowPic(false);
      console.error(error.message);
    }
  };

  return (
    <div
      id="aboutme"
      className={`${
        isDarkMode ? "background-theme-dark" : ""
      } jumbotron jumbotron-fluid m-0 p-3`}
    >
      <div className="container container-fluid">
        <div className="row">
          <motion.div
            variants={appearUp}
            initial="hidden"
            animate={controlsOne}
            ref={refOne}
            className="col-5 d-none d-lg-block align-self-center"
          >
            {showPic && (
              <img
                className="border border-secondary rounded-circle"
                src={profilePicUrl}
                alt="profilepicture"
                width={imgSize}
                height={imgSize}
              />
            )}
          </motion.div>

          <motion.div
            variants={appearUp}
            initial="hidden"
            animate={controlsTwo}
            ref={refTwo}
            className={`col-lg-${showPic ? "7" : "12"}`}
          >
            <h2
              className={`${
                isDarkMode ? "color-theme-light" : ""
              } text-center display-4 mb-5`}
            >
              {heading}
            </h2>
            <p
              className={`${
                isDarkMode ? "color-theme-light" : ""
              } text-right lead`}
            >
              {message}
            </p>
            {resume && (
              <p
                className={`${
                  isDarkMode ? "color_yellow" : ""
                } lead text-center mt-4`}
              >
                <a
                  className={`${
                    isDarkMode
                      ? "color_yellow btn-outline-themelight"
                      : "btn-outline-dark"
                  } btn-lg btn`}
                  style={{ width: "10rem" }}
                  href={resume}
                  target="_blank"
                  rel="noreferrer noopener"
                  role="button"
                  aria-label="Resume/CV"
                >
                  Resume
                </a>
              </p>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
